import React from 'react';
import ErrorBoundary from './ErrorBoundary';

const RouteFallback = ({ error, resetError }) => (
  <div className="route-error-boundary">
    <h2>Bu bölüm yüklenemedi</h2>
    <p>Lütfen tekrar deneyin veya ana sayfaya dönün</p>
    <div className="route-error-actions">
      <button onClick={resetError} className="btn btn-outline">
        Tekrar Dene
      </button>
      <button onClick={() => window.location.href = '/'} className="btn btn-primary">
        Ana Sayfaya Dön
      </button>
    </div>
  </div>
);

const RouteErrorBoundary = ({ children }) => (
  <ErrorBoundary fallback={RouteFallback}>
    {children}
  </ErrorBoundary>
);

export default RouteErrorBoundary;
